<template>
  <div v-if="!isEdit" class="w-full sm:max-w-368 px-16 sm:px-0">
    <slot />
    <form class="flex flex-col mt-24" @submit.prevent="submitForm">
      <h1 class="text-h3 mb-8">Time to set what you’ll charge</h1>
      <div class="flex justify-between border-b-1 border-solid border-grey-divider-subdued py-16">
        <p class="text-body">Activity duration</p>
        <p class="text-body text-grey-text-subdued">{{ duration }} hours</p>
      </div>
      <div class="flex justify-between border-b-1 border-solid border-grey-divider-subdued py-16">
        <p class="text-body">Your base rate</p>
        <p class="text-body text-grey-text-subdued" aria-hidden="true">${{ minRate }}/hr</p>
        <p class="sr-only">{{ minRateLabel }}</p>
      </div>
      <div class="flex justify-between pt-16">
        <p class="text-h4">Subtotal</p>
        <p class="text-h4">${{ subtotal }}</p>
      </div>
      <NoteBox v-if="noteBoxMessage" class="mb-36" header="Note" :body="noteBoxMessage" />
      <StickyButton value="Next" type="submit" />
    </form>
    <Popup v-model="showPopup" popupHeader="Now, calculate your Adventure surcharge">
      <Surcharge :subtotal="subtotal" :adventureMetaData="adventureMetaData" @close="hidePopup" />
    </Popup>
  </div>
  <div v-else-if="isEdit" class="w-full sm:max-w-368 px-16 sm:px-0">
    <slot />
    <Surcharge :subtotal="subtotal" :adventureMetaData="adventureMetaData" :isEdit="isEdit" />
  </div>
</template>

<script lang="ts">
// components
import NoteBox from '../../../components/note_box/NoteBox.vue';
import Popup from '../../../components/popup/Popup.vue';
import Surcharge from './Surcharge.vue';
import StickyButton from '../../../components/sticky_button/StickyButton.vue';

export default {
  name: 'Rate',
  components: { NoteBox, Surcharge, Popup, StickyButton },
  props: {
    adventureMetaData: {
      default: () => {},
      type: Object,
    },
    sitterProfile: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
  data(): any {
    return {
      duration: this.$store.getters['adventures/adventureDraft'].duration / 60,
      showPopup: false,
    };
  },
  computed: {
    minRate(): number {
      const minRate = this.sitterProfile?.minPayRate;
      return Math.floor(minRate / 100);
    },
    subtotal(): number {
      return this.minRate * this.duration;
    },
    noteBoxMessage(): string {
      return 'This base rate is what you’ve set on your babysitter profile. Hit “Next” to add your Adventure’s surcharge.';
    },
    minRateLabel(): string {
      return `$${this.minRate} per hour`;
    },
  },
  methods: {
    submitForm() {
      this.showPopup = true;
    },
    hidePopup() {
      this.showPopup = false;
    },
  },
};
</script>
